(function () {
    let wave;
    let d;
    let x;
    let y;

    function createNewWave(container) {
        const newWave = document.createElement('span');
        container.appendChild(newWave);
        newWave.classList.add('wave');
    }

    function wavePos(e, wave) {
        const offset = function (elt) {
            const rect = elt.getBoundingClientRect();
            const bodyElt = document.body;
            return {
                top: rect.top + bodyElt.scrollTop,
                left: rect.left + bodyElt.scrollLeft,
            };
        };

        x = e.pageX - offset(e.target).left - wave.offsetWidth / 2;
        y = e.pageY - offset(e.target).top - wave.offsetHeight / 2;

        return {
            left: x,
            top: y,
        };
    }

    function handleWave(e) {
        const button = e.target;

        if (!button.querySelector('.wave')) {
            createNewWave(button);
        }

        wave = button.querySelector('.wave');
        wave.classList.remove('waved');

        if (wave.offsetHeight === 0 && wave.offsetWidth === 0) {
            d = Math.max(button.offsetHeight, button.offsetWidth);
            wave.style.width = d + 'px';
            wave.style.height = d + 'px';
        }

        wavePos(e, wave);

        wave.style.top = y + 'px';
        wave.style.left = x + 'px';
        wave.classList.add('waved');
    }

    function initButtons() {
        $(document).on('click', '.button', (e) => {
            if (!e.target.classList.contains('noWave')) {
                handleWave(e);
            }
        });
    }

    initButtons();
})();
